import { Injectable } from '@angular/core';
import {HttpService} from '../../_service/http.service';

@Injectable()
export class FileService {

  readonly BYTES_TO_MB = 1/(1024 * 1024);
  // В МБ
  readonly MAX_FILE_SIZE = 5;
  readonly MAX_FILE_COUNT = 5;
  private isFileValid: boolean = false;

  constructor(private http: HttpService) {
  }

  async upload(inputEl: HTMLInputElement, allowedFileExt: Array<String>,
               alreadyUploadedFilesAmount: number): Promise<Array<File>> {

    console.debug("Files in input are:", inputEl.files);
    let fileCount: number = inputEl.files.length;

    if(alreadyUploadedFilesAmount + fileCount > this.MAX_FILE_COUNT){
      alert('Вы не можете прикрепить больше ' + this.MAX_FILE_COUNT + ' файлов');
      return;
    }
    const files = [];

    for (let i = 0; i < fileCount; i++) {
      await this.checkFile(inputEl.files[i], allowedFileExt);
      console.log("File validity:", this.isFileValid);

      if (this.isFileValid) {
        files.push(inputEl.files[i]);
        this.isFileValid = false;
      }
    }

    return files;
  }

  checkFileFormat(file: File, allowedFileExt: Array<String>) {
    const fileExt = file.name.split('.').pop();
    if(allowedFileExt.some(e => e.toLowerCase() === fileExt.toLowerCase())) {
      this.isFileValid = true;
      return;
    }
    this.isFileValid = false;
    alert('Расширение файла "' + file.name + '" является недопустимым');
  }

  async getFileExtSettings() {
    let sb = [];
    sb.push('file-rest/');
    sb.push('getAllowedFileExtensions');

    let result;
    await this.http.getFilesDataWithAuth(sb.join(''))
      .then((data) => {
        console.log('getAllowedFileExtensions result : ', data);
        result = data;
      }, (error) => {
        console.error('getAllowedFileExtensions error ', error);
        throw error;
      });
    return result;
  }

  async checkFile(file: File, allowedFileExt: Array<String>) {

    if(file.size * this.BYTES_TO_MB > this.MAX_FILE_SIZE) {
      alert('Размер файла "' + file.name + '"'
        + '(' + this.fileInBytesToMBString(file.size) +')'
        + 'превышает максимальный допустимый размер (' + this.MAX_FILE_SIZE + ' Мбайт)');
      this.isFileValid = false;
      return;
    }

    this.checkFileFormat(file, allowedFileExt);
  }

  convertFilesToFormData(files: Array<File>): FormData {
    let formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i], files[i].name);
    }

    return formData;
  }

  fileInBytesToMBString(sizeInBytes: number) {
    return (sizeInBytes * this.BYTES_TO_MB).toFixed(4) + ' МБ';
  }

  private isFileFormatSuitable(fileType) {
    return fileType != 'application/x-msdownload' ||
      fileType != 'application/vnd.microsoft.portable-executable';
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/file/file.service.ts